// Core
import { createActions } from 'redux-actions';

export const hotelsActions = createActions({
    GET_HOTEL:         (hotelId) => hotelId,
    GET_HOTEL_SUCCESS: (hotel) => hotel,
    GET_HOTEL_FAIL:    (error) => error,
    ADD_HOTEL:         (hotel) => hotel,
    ADD_HOTELS:        (hotels) => hotels,
});
